<template>
    <div class="dingFlash">
        <div class="banner"></div>
        <div class="title">闪会</div>
        <div class="box1">
            <ul class="box1-list">
                <li>
                    <div class="list1">
                        <img src="http://img601.yun300.cn/repository/image/5d1775b6-7efa-4420-9144-92de69e47f6e.gif?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                    <div class="list2">
                        <p class="p-title-head">闪电回顾，快速同步</p>
                        <p class="p-info-shanhui">往期遗留任务导入本期会议，快速回顾工作进展。决策先机，始于开会之前</p>
                    </div>
                </li>
                <li>
                    <div class="lists1">
                        <p class="p-title-head">闪电回顾，快速同步</p>
                        <p class="p-info-shanhui">往期遗留任务导入本期会议，快速回顾工作进展。决策先机，始于开会之前</p>
                    </div>
                    <div class="lists2">
                        <img src="http://img601.yun300.cn/repository/image/bb1a7cfa-e4ee-4daf-b3b1-b4ebca8e357d.gif?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                </li>
                <li>
                    <div class="list1">
                        <img src="http://img601.yun300.cn/repository/image/33d4d9cb-8e7b-45c2-a6ce-c90763fcceef.gif?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                    <div class="list2">
                        <p class="p-title-head">会后有结论，任务可提醒</p>
                        <p class="p-info-shanhui">会议结论当场记录，一键转成待办任务，会后随时跟进</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="title ts1">闪记</div>
        <div class="box1 ts1">
            <ul class="box1-list ts1">
                <li class="ts2">
                    <div class="list1">
                        <img src="http://img601.yun300.cn/repository/image/17309692-a472-48fd-806d-6e1c01fa6e53.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                    <div class="list2">
                        <p class="p-title-head">会议全景录制，会后立体回顾</p>
                        <p class="p-info-shanhui">会中录制，会后快速转文字，云端保存音/画/字，立体式记录会议内容</p>
                    </div>
                </li>
                <li class="ts2">
                    <div class="lists1">
                        <p class="p-title-head">筛选关键词、发言人</p>
                        <p class="p-info-shanhui">智能提炼会议关键词，语音识别多位发言人，通过筛选、定位，提炼要点内容</p>
                    </div>
                    <div class="lists2">
                        <img src="http://img601.yun300.cn/repository/image/cca35119-164f-46fc-97c9-04eadbe73c28.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                </li>
                <li class="ts2">
                    <div class="list1">
                        <img src="http://img601.yun300.cn/repository/image/bd0d5747-9262-4b6f-ad92-232c8164398c.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                    <div class="list2">
                        <p class="p-title-head">一键分享，不在会场如临现场</p>
                        <p class="p-info-shanhui">支持一键分享赋权给未参会成员，未能参会也能高效获取会议重点</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="title">闪享</div>
        <div class="box1">
            <ul class="box1-list">
                <li>
                    <div class="list1">
                        <img src="http://img601.yun300.cn/repository/image/16c222a0-0338-4320-800c-29b2705931af.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                    <div class="list2">
                        <p class="p-title-head">离队、跟队双模式，快速查看</p>
                        <p class="p-info-shanhui">会中共享文档，参会人可选择跟随主持人，也可以选择自由浏览</p>
                    </div>
                </li>
                <li>
                    <div class="lists1">
                        <p class="p-title-head">穿屏协作，共同编辑</p>
                        <p class="p-info-shanhui">共享文档支持穿屏打开，画面更清晰，参会人可在文档内进行共同编辑</p>
                    </div>
                    <div class="lists2">
                        <img src="http://img601.yun300.cn/repository/image/5173f4b0-9dc3-4b07-8132-dc37e104e471.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                </li>
                <li>
                    <div class="list1">
                        <img src="http://img601.yun300.cn/repository/image/9360dde6-db53-4690-88ec-3c79dbaf75f1.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                    </div>
                    <div class="list2">
                        <p class="p-title-head">多种文件类型均可闪享</p>
                        <p class="p-info-shanhui">文档、表格和演示文稿，多种格式均支持在线闪享，可自由浏览以及编辑协作</p>
                    </div>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
export default {

}
</script>
<style lang='less' scoped>
.dingFlash{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url(./banner-pc-img/cpfw_dsh_1920337.5@1x.png);
        background-size: 100%;
        background-repeat: no-repeat;
    }
    .title{
        background-color: rgba(247, 248, 250, 1);
        width: 100%;
        font-size:36px ;
        color:#0089ff;
        font-weight: bold;
        margin: 0 auto;
        text-align: center;
        padding: 40px;
    }

    .box1{
        background-color: rgba(247, 248, 250, 1);
        width: 100%;
        ul.box1-list{
            width: 100%;
            margin: 0 auto;
            padding-bottom: 40px;
            li{
                width: 50%;
                background-color: #fff;
                border-radius: 12px;
                padding: 20px;
                display: flex;
                margin: 0 auto;
                margin-bottom: 30px;
                .list1{
                    width: 50%;
                    height: 100%;
                    border-radius: 12px;
                    img{
                        width: 100%;
                        height: 350px;
                        border-radius: 12px;
                    }
                }
                .list2{
                    width: 50%;
                    height: 100%;
                    padding: 40px;
                    .p-title-head{
                        font-size: 26px;
                        color: #000;
                        font-weight: bold;
                        margin-bottom: 15px;
                    }
                    .p-info-shanhui{
                        font-size:16px;
                        color:#696969;
                        line-height: 25px;
                    }
                }
                .lists1{
                    width: 50%;
                    height: 100%;
                    border-radius: 12px;
                    padding: 20px;
                    .p-title-head{
                        font-size: 26px;
                        color: #000;
                        font-weight: bold;
                        margin-bottom: 15px;
                    }
                    .p-info-shanhui{
                        font-size:16px;
                        color:#696969;
                        line-height: 25px;
                    }
                }
                .lists2{
                    width: 50%;
                    height: 100%;
                    border-radius: 12px;
                    img{
                        width: 100%;
                        height: 100%;
                        border-radius: 12px;
                    }
                }
            }
        }
    }
}
.ts1{
    background-color: #fff!important;
}
.ts2{
    background-color: rgba(247, 248, 250, 1)!important;
}
</style>
